import { CustomDialog } from "../../../../../../../../../components/dialog/v1/CustomDialog";
import styled from 'styled-components';
import { CustomLabelInput } from "../../../../../../../../../components/input/CustomLabelInput";
import { useState } from "react";
import { v4 as uuidv4 } from 'uuid';
import CustomBlockButton from "../../../../../../../../../components/button/CustomBlockButton";
import { customToast } from "../../../../../../../../../components/toast/custom-react-toastify/v1";

const StyledHeader = styled.div`
    padding: 10px;
`;

const StyledBody = styled.div`
    padding: 10px;

    input{
        border-color: #e0e0e0;
        border-radius: 3px;
    }
`;

const StyledFooter = styled.div`
    padding: 10px;
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    button{
        width: 100px;
        border-radius: 3px;
        background-color: #333;
        color: #fff;
        border: none;
        font-weight: 600;

        &.cancel{
            background-color: #efefef;
            color: #333;
        }
    }
`;

export function FragmentAddPurchaseRecordModal({
    open,
    onClose,
    onConfirm
}) {
    const [formData, setFormData] = useState({
        uuid: uuidv4(),
        memo: '',
        createdAt: null,
        updatedAt: null,
    })

    const handleSubmit = async () => {
        if (!formData.memo) {
            customToast.error('메모를 입력해주세요.');
            return;
        }
        onConfirm(formData);
    }

    return (
        <>
            <CustomDialog
                open={open}
                onClose={onClose}
            >
                <StyledHeader>
                    <CustomDialog.Header>
                        <CustomDialog.Header.Fake />
                        <CustomDialog.Header.Title>구매 기록 생성</CustomDialog.Header.Title>
                        <CustomDialog.Header.Close onClick={onClose} />
                    </CustomDialog.Header>
                </StyledHeader>
                <form
                    onSubmit={(e) => {
                        e.preventDefault();
                        handleSubmit();
                    }}
                >
                    <StyledBody>
                        <CustomLabelInput>
                            <CustomLabelInput.Input
                                type='text'
                                value={formData?.memo || ''}
                                onChange={(e) => setFormData({ ...formData, memo: e.target.value })}
                                autoFocus
                            />
                            <CustomLabelInput.Label>메모</CustomLabelInput.Label>
                        </CustomLabelInput>
                    </StyledBody>
                    <StyledFooter>
                        <CustomBlockButton
                            type='button'
                            className='cancel'
                            onClick={onClose}
                        >
                            취소
                        </CustomBlockButton>
                        <CustomBlockButton
                            type='submit'
                        >
                            확인
                        </CustomBlockButton>
                    </StyledFooter>
                </form>
            </CustomDialog>
        </>
    );
}